import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Read state is tracked entirely client-side: a per-workshop "last read" timestamp. A notification
// is unread when its `createdAt` is newer than `lastReadAtTs[workshopId]`. Keyed by workshop so
// marking one workshop's notifications as seen never clears another's badge.
export type NotificationsState = {
  lastReadAtTs: Record<string, string>
}

const initialState: NotificationsState = {
  lastReadAtTs: {},
}

const key = 'notifications'

const NotificationsSlice = createSlice({
  initialState,
  name: key,
  reducers: {
    markWorkshopRead(state, action: PayloadAction<{ workshopId: string; ts: string }>) {
      state.lastReadAtTs[action.payload.workshopId] = action.payload.ts
    },
  },
})

export const NotificationsReducer = persistReducer(
  {
    key,
    storage,
    whitelist: ['lastReadAtTs'],
  },
  NotificationsSlice.reducer,
)

export const NotificationsActions = NotificationsSlice.actions
